import {Spin} from 'antd'

const Loader = () => {
    return(
        <div className="flex-container">
            <Spin size = 'large' />
        </div>
    )
}
export default Loader;